export const GET_NOTIFICATION_SUMMARY = "GET_NOTIFICATION_SUMMARY";
